import { NavLink, Navigate, Outlet } from "react-router-dom";
import { Loader2, LogOut } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const NAV = [
  { to: "/staff/leads", label: "Leads" },
  { to: "/staff/funnel", label: "Funnel", admin: true },
  { to: "/staff/team", label: "Team", admin: true },
  { to: "/staff/cities", label: "Cities", admin: true },
  { to: "/staff/settings", label: "Settings", admin: true },
];

export default function StaffLayout() {
  const { user, logout } = useAuth();
  if (user === null)
    return <div className="flex h-screen items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-neutral-400" /></div>;
  if (!user) return <Navigate to="/staff" replace />;
  const isAdmin = user.role === "super_admin";

  return (
    <div className="min-h-screen bg-[#f7f5f1]" data-testid="staff-layout">
      <div className="tricolour-line" />
      <header className="border-b border-neutral-200 bg-white">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-x-6 gap-y-2 px-4 py-3">
          <p className="font-display text-lg text-[#1f2328]">PropertiesforNRI <span className="text-xs text-[#138808]">Staff</span></p>
          <nav className="order-3 -mx-1 flex w-full gap-1 overflow-x-auto sm:order-none sm:w-auto">
            {NAV.filter((n) => !n.admin || isAdmin).map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                className={({ isActive }) => `whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${isActive ? "bg-[#1f2328] text-white" : "text-neutral-600 hover:bg-neutral-100"}`}
                data-testid={`staff-nav-${n.label.toLowerCase()}`}
              >
                {n.label}
              </NavLink>
            ))}
          </nav>
          <div className="ml-auto flex items-center gap-3 text-sm">
            <span className="hidden text-neutral-600 sm:inline" data-testid="staff-current-user">
              {user.name} · <span className="text-neutral-400">{isAdmin ? "Super Admin" : "Telecaller"}</span>
            </span>
            <button onClick={logout} className="flex h-10 items-center gap-1.5 rounded-full px-3 text-neutral-600 hover:bg-neutral-100" data-testid="staff-logout-button">
              <LogOut className="h-4 w-4" /> Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}

export const AdminOnly = ({ children }) => {
  const { user } = useAuth();
  return user?.role === "super_admin" ? children : <Navigate to="/staff/leads" replace />;
};
